import styled from 'styled-components';
import { Input } from 'antd';

export const TextAreaWrapper = styled(Input.TextArea)`
	textarea {
		font-size: 1rem;
		border-radius: 4px;
	}
`;
